var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileRotate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1366 1366",
    width: 300,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Dynamic_Info Page-ai") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #4bccea } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m463.9 289.4c-6.4 0-12.6-2.9-16.7-8.4-7-9.2-5.1-22.3 4.2-29.2l61.1-45.9-61.1-45.9c-9.3-6.9-11.2-19.9-4.2-29.2 6.9-9.2 20-11 29.2-4.1l83.4 62.6c5.3 3.9 8.4 10.1 8.4 16.6 0 6.6-3.1 12.8-8.4 16.7l-83.4 62.6c-3.8 2.8-8.2 4.2-12.5 4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m776.8 393.7h-83.4c-11.5 0-20.8-9.4-20.8-20.9 0-11.5 9.3-20.8 20.8-20.8h83.4c34.5 0 62.6-28.1 62.6-62.6 0-34.5-28.1-62.6-62.6-62.6-11.6 0-20.9-9.3-20.9-20.9 0-11.5 9.3-20.8 20.9-20.8 57.5 0 104.3 46.8 104.3 104.3 0 57.5-46.8 104.3-104.3 104.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m568.2 393.7h-104.3c-57.6 0-104.3-46.8-104.3-104.3 0-57.5 46.7-104.3 104.3-104.3h41.7c11.5 0 20.8 9.3 20.8 20.8 0 11.6-9.3 20.9-20.8 20.9h-41.7c-34.6 0-62.6 28.1-62.6 62.6 0 34.5 28 62.6 62.6 62.6h104.3c11.6 0 20.9 9.3 20.9 20.8 0 11.5-9.3 20.9-20.9 20.9z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m1068.8 664.9v104.3c0 42.5-7.3 115.2-21.4 171.9-32.3 129.8-104.6 182.7-249.8 182.7-249.5 0-339.6-236.2-369.3-313.9l-4.7-12.1c-39.6-99.2-99.1-159.3-99.7-159.9-5.3-5.3-6.7-12.7-5.1-19.5 0.1-0.8 0.2-1.6 0.4-2.4 0.4-1.1 1.1-1.9 1.6-2.9 0.6-1.1 1-2.3 1.9-3.3 27-32.4 56.2-49.4 86.9-50.5 52.2-1.5 92.5 40.6 125.1 74.6 3.9 4 8.3 8.6 12.6 12.9v-336.6c0-46 37.5-83.4 83.5-83.4 46 0 83.4 37.4 83.4 83.4v199c12.3-7.1 26.5-11.2 41.7-11.2 30.3 0 56.9 16.2 71.5 40.5 14.5-12.3 33.3-19.6 53.7-19.6 36 0 66.8 22.9 78.5 55 24.7-9.7 60.5-8.2 82.3 13.7 26.9 27 26.9 54.9 26.9 77.3zm-41.7 104.3v-104.3c0-19.2 0-33.1-14.8-47.9-7.5-7.6-24.9-9.4-37.9-4.1-4.5 1.9-9.9 5.2-9.9 10.3v20.8c0 11.5-9.3 20.9-20.8 20.9-11.6 0-20.9-9.4-20.9-20.9v-41.7c0-23-18.7-41.7-41.7-41.7-23 0-41.7 18.7-41.7 41.7v20.9c0 11.5-9.4 20.8-20.9 20.8-11.5 0-20.9-9.3-20.9-20.8v-41.8c0-23-18.7-41.7-41.7-41.7-23 0-41.7 18.7-41.7 41.7v41.8c0 11.5-9.3 20.8-20.9 20.8-11.5 0-20.8-9.3-20.8-20.8v-313c0-23-18.7-41.7-41.7-41.7-23 0-41.8 18.7-41.8 41.7v417.3c0.2 2.1 0.5 29.8-26 56.4-8.1 8.2-21.3 8.2-29.5 0.1-8.2-8.2-8.2-21.4 0-29.6 13.5-13.5 13.8-26 13.8-26.6v-27.3c-13.6-7.6-27-21.4-42.7-37.7-26.9-28.1-60.1-63.3-93.6-61.8-14.2 0.5-28.8 7.9-43.5 21.9q0.1 0.1 0.2 0.3h-0.8c21.4 24.9 64 80.3 95.5 159.1 1.4 3.5 3 7.8 4.9 12.7 27.1 71 109.6 287.1 330.3 287.1 125.2 0 181.9-40.9 209.3-151.1 13.3-53.4 20.2-121.9 20.2-161.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileRotate);
export default __webpack_public_path__ + "static/media/mobile-rotate.1563001e5a62068049b08fc61944d890.svg";
export { ForwardRef as ReactComponent };